import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'cepMask'})
export class CepMaskPipe implements PipeTransform {
    transform(value: string): any {
        if (value === undefined || value === null) throw new Error('valor não pode ser nulo!');
        
        if (value.length < 8) {
            throw new Error('valor não pode ter menos de 8 caracteres!');
        }

        return value.substr(0, 5).concat('-', value.substr(5, 8));
    }
}


// WEBPACK FOOTER //
// C:/Users/anderson.oshiro/Projetos/Azure/Ipcorp.PortalCobranca/Web/Ipcorp.PortalCobranca.Web/src/app/shared/pipes/cep-mask.pipe.ts